module.exports = __webpack_public_path__ + "img/normal_multiplier.460885f3.png";